// encrypt-jwt.service.ts
import { Injectable } from '@angular/core';
import { CompactEncrypt, importJWK } from 'jose';

@Injectable({
  providedIn: 'root',
})
export class EncryptJwtService {
  jwe: string;
  constructor() {
  }

  async encryptJwt(payload: string): Promise<string> {
    
    const modulus = sessionStorage.getItem('modulus');
    const exponent = sessionStorage.getItem('exponent');

    // 1. Construct JWK from modulus & exponent
    const rsaJwk = {
      kty: 'RSA',
      n: modulus,
      e: exponent,
      alg: 'RSA-OAEP-256',
      ext: true,
    };
    try {
       // 2. Import the public key
      const publicKey = await importJWK(rsaJwk, 'RSA-OAEP-256');

      // 3. Stringify and encode the JWT payload
      const encodedPayload = new TextEncoder().encode(payload);
      
      this.jwe = await new CompactEncrypt(encodedPayload)
        .setProtectedHeader({
          alg: 'RSA-OAEP-256',
          enc: 'A256GCM',
        })
        .encrypt(publicKey);
    } catch (e) {
    }

    return this.jwe;
  }
}
